import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthXService } from '@brg/auth';
import { useLocation } from 'react-router-dom';
import { AppTester } from '../../../../supporting';
import { SEGMENTS_CONFIG, DafesSegment } from '../../../../_kz/dafes/constants/segments';
import { useGalleryArtContexts } from './galleryArtContext';

const PRO_DAFES_LINK = 'https://pro.dafes.net'
const EDUCATION_DAFES_LINK = 'https://edu.dafes.net'

export const useGetDafesContexts = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  // const baseURL = typeof window !== 'undefined' ? window.location.origin : '';
  const baseURL = ''
  const suffix = AuthXService.isAuthenticated() ? '?shouldLogin=true&saveLoginUrl=true' : '';
  const isNewDafesSegment = AppTester.isNewDafesSegment();
  const isBrandsPage = pathname.startsWith('/brands');

  const galllleryArtLink = useGalleryArtContexts().links

  const links = useMemo(
    () =>
      [...(Object.keys(SEGMENTS_CONFIG) as DafesSegment[]).map((segmentId) => {
        const config = SEGMENTS_CONFIG[segmentId];
        const contextKey = segmentId === DafesSegment.Main ? 'dafes' : `dafes-${segmentId}`;
        const isActive = isNewDafesSegment && isBrandsPage
          ? segmentId === DafesSegment.Shop
          : segmentId === DafesSegment.Main
            ? AppTester.isContext('dafes')
            : AppTester.isContext(contextKey);
        const url = config.url === '/' ? '' : config.url;
        const fullPath = url ? url : '/';

        return {
          id: `dafes-${segmentId}`,
          active: isActive,
          content: t(`nav.dafes_nav.${segmentId}`),
          linkTo: `${baseURL}${fullPath}`,
          action: () => {
            window.open(`${baseURL}${fullPath}${suffix}`, '_self');
          },
          target: '_self' as const,
          level: 1,
          hasChildren: true,
          hasCornerArrow: false,
          hidden: false,
        };
      }), ...galllleryArtLink],
    [baseURL, suffix, t, isNewDafesSegment, isBrandsPage]
  );

  return {
    links,
    modalSettings: {
      titleColor: '#151514',
      title: 'dafes',
    },
  };
};
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthXService } from '@brg/auth';
import { useLocation } from 'react-router-dom';
import { AppTester } from '../../../../supporting';
import { SEGMENTS_CONFIG, DafesSegment } from '../../../../_kz/dafes/constants/segments';
import { useGalleryArtContexts } from './galleryArtContext';

const PRO_DAFES_LINK = 'https://pro.dafes.net'
const EDUCATION_DAFES_LINK = 'https://edu.dafes.net'

export const useGetDafesContexts = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  // const baseURL = typeof window !== 'undefined' ? window.location.origin : '';
  const baseURL = ''
  const suffix = AuthXService.isAuthenticated() ? '?shouldLogin=true&saveLoginUrl=true' : '';
  const isNewDafesSegment = AppTester.isNewDafesSegment();
  const isBrandsPage = pathname.startsWith('/brands');

  const galllleryArtLink = useGalleryArtContexts().links

  const links = useMemo(
    () =>
      [...(Object.keys(SEGMENTS_CONFIG) as DafesSegment[]).map((segmentId) => {
        const config = SEGMENTS_CONFIG[segmentId];
        const contextKey = segmentId === DafesSegment.Main ? 'dafes' : `dafes-${segmentId}`;
        const isActive = isNewDafesSegment && isBrandsPage
          ? segmentId === DafesSegment.Shop
          : segmentId === DafesSegment.Main
            ? AppTester.isContext('dafes')
            : AppTester.isContext(contextKey);
        const url = config.url === '/' ? '' : config.url;
        const fullPath = url ? url : '/';

        return {
          id: `dafes-${segmentId}`,
          active: isActive,
          content: t(`nav.dafes_nav.${segmentId}`),
          linkTo: `${baseURL}${fullPath}`,
          action: () => {
            window.open(`${baseURL}${fullPath}${suffix}`, '_self');
          },
          target: '_self' as const,
          level: 1,
          hasChildren: true,
          hasCornerArrow: false,
          hidden: false,
        };
      }), ...galllleryArtLink],
    [baseURL, suffix, t, isNewDafesSegment, isBrandsPage]
  );

  return {
    links,
    modalSettings: {
      titleColor: '#151514',
      title: 'dafes',
    },
  };
};
